function isFunction(value) {
  return typeof value === 'function';
}

export { isFunction as i };
//# sourceMappingURL=isFunction-DjxTmSal.js.map
